import { urbanColors } from "@urbaninstitute/dataviz-components/utils";

export let tool_title =
  "Explore Federal Spending on Major Recurring Place-Based Programs Over Time";
export let instructional_text =
  "Explore spending by category using the buttons below. Use the dropdown or click on the chart to select an individual program.";

export let content_box_sentences = {
  overview:
    "In 2024, the federal government spent <b>$60.7 billion</b> on federal place-based programs. Adjusted for inflation, that’s a <b>37.4 percent increase</b> from 2010.",
  direct:
    "Of the $60.7 billion the federal government spent on place-based programs <b>in 2024, 15.7 percent, or $9.5 billion, was through direct spending.</b><br><br>By comparison, <b>in 2010</b> the federal government spent a total of $44.1 billion on place-based programs. <b>$15.1 billion, or 34.1 percent, was through direct spending.</b>",
  tax: "Of the $60.7 billion the federal government spent on place-based programs <b>in 2024, 84.3 percent, or $51.1 billion, was through tax expenditures.</b><br><br>By comparison, <b>in 2010</b> the federal government spent $44.1 billion on place-based programs. <b>$29 billion, or 65.9 percent, was through tax expenditures.</b>",
  category_highlighted:
    "In 2024, the federal government spent <b>[XX]</b> on the [XX] program. Adjusted for inflation, that’s [XX]</b> from 2010."
};

export let metadata = [
  {
    variable: "lihtc",
    label: "Low-Income Housing Tax Credit (LIHTC)",
    short_label: "LIHTC",
    category: "Tax expenditures",
    color: urbanColors.blue_shade_darker,
    now_number: "$34.3 billion",
    percent_inflation: "an <b>83.0 percent increase"
  },
  {
    variable: "oz",
    label: "Opportunity Zones (OZ)",
    short_label: "OZ",
    category: "Tax expenditures",
    color: urbanColors.blue_shade_dark,
    now_number: "$5.4 billion",
    percent_inflation: "a <b>177.2 percent increase from 2018,",
    extra_text: "</b> when the program began."
  },
  {
    variable: "nmtc",
    label: "New Markets Tax Credit (NMTC)",
    short_label: "NMTC",
    category: "Tax expenditures",
    color: urbanColors.blue_shade_light,
    now_number: "$5.2 billion",
    percent_inflation: "a <b>2.5 percent decrease"
  },
  {
    variable: "htc",
    label: "Historic Tax Credit (HTC)",
    short_label: "HTC",
    category: "Tax expenditures",
    color: urbanColors.blue_shade_lightest,
    now_number: "$6.3 billion",
    percent_inflation: "a <b>25.1 percent increase"
  },
  {
    variable: "usda_rd",
    label: "US Department of Agriculture Rural Development (USDA RD)",
    short_label: "USDA RD",
    category: "Direct spending",
    color: urbanColors.yellow_shade_darkest,
    now_number: "$3.7 billion",
    percent_inflation: "a <b>16.5 percent decrease"
  },
  {
    variable: "cdbg",
    label: "Community Development Block Grant (CDBG)",
    short_label: "CDBG",
    category: "Direct spending",
    color: urbanColors.yellow_shade_darker,
    now_number: "$3.4 billion",
    percent_inflation: "a <b>48.4 percent decrease"
  },
  {
    variable: "eda",
    label: "US Economic Development Administration (EDA)",
    short_label: "EDA",
    category: "Direct spending",
    color: urbanColors.yellow_shade_dark,
    now_number: "$481 million",
    percent_inflation: "a <b>6.2 percent decrease"
  },
  {
    variable: "home",
    label:
      "US Department of Housing and Urban Development HOME Investment Partnerships Program (HOME)",
    short_label: "HOME",
    category: "Direct spending",
    color: urbanColors.yellow,
    now_number: "$1.3 billion",
    percent_inflation: "a <b>52.4 percent decrease"
  },
  {
    variable: "choice_neighborhoods",
    label: "Choice Neighborhoods",
    short_label: "Choice Neighborhoods",
    category: "Direct spending",
    color: urbanColors.yellow_shade_light,
    now_number: "$77.2 million",
    percent_inflation: "a <b>73.9 percent decrease"
  },
  {
    variable: "cdfi",
    label: "Community Development Financial Institutions (CDFI) Fund programs",
    short_label: "CDFI",
    category: "Direct spending",
    color: urbanColors.yellow,
    now_number: "$333 million",
    percent_inflation: "a <b>35.9 percent increase"
  },
  {
    variable: "epa_brownfields",
    label: "US Environmental Protection Agency (EPA) Brownfields and Land Revitalization",
    short_label: "EPA Brownfields",
    category: "Direct spending",
    color: urbanColors.yellow_shade_dark,
    now_number: "$174 million",
    percent_inflation: "a <b>32.0 percent decrease"
  },
  {
    variable: "promise_neighborhoods",
    label: "Promise Neighborhoods",
    short_label: "Promise Neighborhoods",
    category: "Direct spending",
    color: urbanColors.yellow_shade_darker,
    now_number: "$94 million",
    percent_inflation: "a <b>533.5 percent increase"
  },
  {
    variable: "hhs_ced_and_rcd",
    label:
      "US Department of Health and Human Services Community Economic Development program (HHS CED)",
    short_label: "HHS CED",
    category: "Direct spending",
    color: urbanColors.yellow_shade_darkest,
    now_number: "$35 million",
    percent_inflation: "a <b>48.5 percent decrease"
  }
];
